var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledCheck = function SvgCircledCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M19.63 32.419c.549 0 1.01-.286 1.338-.79l10.66-16.648c.198-.307.395-.702.395-1.053 0-.746-.68-1.25-1.382-1.25-.438 0-.855.263-1.184.745l-9.914 15.683-5.045-6.229c-.395-.526-.79-.68-1.25-.68-.724 0-1.316.592-1.316 1.338 0 .373.153.746.394 1.075l5.857 7.019c.439.548.877.79 1.448.79"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#007AFF",
    strokeWidth: 2
  })));
};
export default SvgCircledCheck;